import React, { useState } from 'react'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import formatCurrency from 'utils/formatCurrency'
import { Box, Grid, Typography, ButtonGroup, Paper, Button } from '@material-ui/core'

export default function GivingSummary() {
  const timeFrameMapping = [
    { value: 'thisWeek', label: 'this week' },
    { value: 'thisMonth', label: 'this month' },
    { value: 'thisYear', label: 'this year' },
    { value: 'toDate', label: 'to date' }
  ]
  const [timeFrame, setTimeFrame] = useState(timeFrameMapping[0].value)
  const donationSums = useCurrentUserProp('historicDonationSums')
  const roundupCounts = useCurrentUserProp('historicRoundupCounts')
  const titheCounts = useCurrentUserProp('historicTitheCounts')

  function renderToggleButton(value, label) {
    function handleClick() {
      setTimeFrame(value)
    }

    return (
      <Button key={value} variant={value === timeFrame ? 'contained' : ''} onClick={handleClick}>
        {label}
      </Button>
    )
  }

  return (
    <Box component={Paper} py={1} px={2}>
      <Grid container alignItems='center' justifyContent='space-around'>
        <Box component={Grid} item textAlign='center' color='secondary.main'>
          <Typography variant='h5'>
            {formatCurrency(donationSums[timeFrame])} given
          </Typography>
          <Typography variant='subtitle2'>
            {titheCounts[timeFrame]} tithes
          </Typography>
          <Typography variant='subtitle2'>
            {roundupCounts[timeFrame]} roundups
          </Typography>
        </Box>

        <Grid item>
          <ButtonGroup orientation='vertical' variant='text' color='primary'>
            {timeFrameMapping.map(({ value, label }) => (
              renderToggleButton(value, label)
            ))}
          </ButtonGroup>
        </Grid>
      </Grid>
    </Box>
  )
}
